import { render, staticRenderFns } from "./JobList.vue?vue&type=template&id=4c62072e&scoped=true"
import script from "./JobList.vue?vue&type=script&lang=ts"
export * from "./JobList.vue?vue&type=script&lang=ts"
import style0 from "./JobList.vue?vue&type=style&index=0&id=4c62072e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c62072e",
  null
  
)

export default component.exports